export enum ProviderCodeEnum {
  mobitopup = "mobitopup",
  b2b = "b2b",
  smm = "smm",
  neci = "neci"
}
